<span class="screenreader-only">
    <slot />
</span>

<style>
    .screenreader-only {
        display: block;
        height: 1px;
        width: 1px;
        position: absolute;
        left: -100000px;
    }
</style>
